import { BaseModel } from "../abstracts/base.model";
import { ExamAnswerListModel } from './exam-answer-list.model';
import { ExamBookletModel } from './exam-booklet.model';

export class ExamModel extends BaseModel {
  ExamID: string;
  LessonID: string;
  ClassLevelID: string;
  InstructorID: string;
  ExamTitle: string;
  NumberOfQuestion: number;
  NumberOfAnswer: number;
  NumberOfAnswerList: number;
  NumberOfBookletList: number;
  TotalMark: number;
  CorrectAnswerEquivalent: number;
  PublishDate: Date;
  StartDate: Date;
  EndDate: Date;
  Duration: number;
  ExamTypeID: number;
  RelatedExamID: number;
  StatusID: number;
  ClassIDs: string[];
  
  ExamBooklets: ExamBookletModel[];
  LessonName: string
  ClassLevel: boolean
  FirstName: string
  LastName: string
  FullName:string;
  Classes:string;
  StatusDescription:string;
}
